// @ts-check
// ====== F6: Excel preset extra — Audit, Matrice accessi pivot, Scadenze annuali ======
// Aggiunge 3 nuovi bottoni di export accanto a "XLSX" nella vista Clienti.
// Riusa la libreria `xlsx` già caricata da xlsx-export.js.

async function getXlsxLib() {
  // @ts-ignore — lib dyn import
  const mod = await import('xlsx');
  return mod;
}

function sanitizeSheetNameP(s) {
  return (
    String(s || 'Sheet')
      .replace(/[\\/?*[\]:]/g, ' ')
      .slice(0, 31)
      .trim() || 'Sheet'
  );
}

/** Preset A: storico audit log. */
async function exportAuditXlsx() {
  // @ts-ignore — isAdmin globale
  if (!isAdmin()) return;
  try {
    const XLSX = await getXlsxLib();
    // @ts-ignore — state globale
    const rows = (state?.auditLog || []).map((a) => ({
      Quando: a.timestamp,
      Utente: a.user || '',
      Azione: a.action,
      Entità: a.entity || '',
      Target: a.target || '',
      Dettagli: a.details || '',
      IP: a.ip || '',
      'User-Agent': a.userAgent || ''
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, sanitizeSheetNameP('Audit'));
    const ts = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `portale-mase_audit_${ts}.xlsx`);
    // @ts-ignore
    toast('Export Audit completato');
    // @ts-ignore
    logAudit?.({
      action: 'system',
      entity: 'Export',
      target: 'XLSX Audit',
      details: `Export audit log: ${rows.length} voci`
    });
  } catch (e) {
    console.error(e);
    // @ts-ignore
    toast('Errore export Audit: ' + (e.message || e));
  }
}

/** Preset B: matrice accessi cliente × risorsa (pivot). */
async function exportMatricePivotXlsx() {
  // @ts-ignore
  if (!isAdmin()) return;
  try {
    const XLSX = await getXlsxLib();
    // @ts-ignore — state
    const clients = (state?.clients || []).slice().sort((a, b) => a.nome.localeCompare(b.nome));
    // @ts-ignore
    const resources = (state?.resources || []).slice().sort();
    const rows = clients.map((c) => {
      const r = { Cliente: c.nome };
      resources.forEach((res) => {
        r[res] = c.accessi?.[res] || '';
      });
      return r;
    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(rows);
    // Colonne automatiche; mantieni l'ordine clienti × risorse
    XLSX.utils.book_append_sheet(wb, ws, sanitizeSheetNameP('Matrice accessi'));
    const ts = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `portale-mase_matrice-accessi_${ts}.xlsx`);
    // @ts-ignore
    toast('Export matrice pivot completato');
    // @ts-ignore
    logAudit?.({
      action: 'system',
      entity: 'Export',
      target: 'XLSX Matrice',
      details: `Matrice ${clients.length} × ${resources.length}`
    });
  } catch (e) {
    console.error(e);
    // @ts-ignore
    toast('Errore export matrice: ' + (e.message || e));
  }
}

/** Preset C: scadenze annuali raggruppate per mese. */
async function exportScadenzeAnnualiXlsx() {
  // @ts-ignore
  if (!isAdmin()) return;
  try {
    const XLSX = await getXlsxLib();
    // @ts-ignore — state globale
    const clients = state?.clients || [];
    const wb = XLSX.utils.book_new();
    // 1 foglio per ciascun anno (corrente + prossimo)
    const now = new Date();
    const years = [now.getFullYear(), now.getFullYear() + 1];
    years.forEach((y) => {
      const rows = [];
      clients.forEach((c) => {
        (c.scadenze || []).forEach((s) => {
          if (!s.data) return;
          const d = new Date(s.data);
          if (d.getFullYear() !== y) return;
          rows.push({
            Cliente: c.nome,
            CPL: c.cpl || '',
            Mese: d.toLocaleString('it-IT', { month: 'long' }),
            Data: s.data,
            Titolo: s.titolo || '',
            Tipo: s.tipo || '',
            Stato: s.completata ? 'Completata' : 'Aperta',
            Note: s.note || ''
          });
        });
        if (c.contratto?.fine) {
          const d = new Date(c.contratto.fine);
          if (d.getFullYear() === y) {
            rows.push({
              Cliente: c.nome,
              CPL: c.cpl || '',
              Mese: d.toLocaleString('it-IT', { month: 'long' }),
              Data: c.contratto.fine,
              Titolo: 'Fine contratto',
              Tipo: 'Contratto',
              Stato: 'Aperto',
              Note: c.contratto.numero || ''
            });
          }
        }
      });
      const ws = XLSX.utils.json_to_sheet(
        rows.sort((a, b) => (a.Data > b.Data ? 1 : a.Data < b.Data ? -1 : 0))
      );
      XLSX.utils.book_append_sheet(wb, ws, sanitizeSheetNameP(`Scadenze ${y}`));
    });
    const ts = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `portale-mase_scadenze-annuali_${ts}.xlsx`);
    // @ts-ignore
    toast('Export scadenze annuali completato');
    // @ts-ignore
    logAudit?.({
      action: 'system',
      entity: 'Export',
      target: 'XLSX Scadenze annuali',
      details: `Coperti anni ${years.join('/')}`
    });
  } catch (e) {
    console.error(e);
    // @ts-ignore
    toast('Errore export scadenze: ' + (e.message || e));
  }
}

// Mount: aggiungi i bottoni accanto a btnExportXLSX se presente
function mountPresetButtons() {
  const ref = document.getElementById('btnExportXLSX');
  if (!ref || document.getElementById('btnExportXLSX_presets')) return;
  const span = document.createElement('span');
  span.id = 'btnExportXLSX_presets';
  span.className = 'admin-only';
  // display:contents così i bottoni si inseriscono come voci del menù "Esporta / Importa"
  span.style.display = 'contents';
  span.innerHTML = `
    <button class="menu-item" type="button" id="btnExportAuditXlsx" title="Storico completo delle modifiche, in Excel">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M3 12h18M3 18h18"/></svg>Esporta storico modifiche
    </button>
    <button class="menu-item" type="button" id="btnExportMatriceXlsx" title="Tabella cliente × risorsa con lo stato di ogni accesso">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>Esporta matrice accessi
    </button>
    <button class="menu-item" type="button" id="btnExportScadenzeAnnoXlsx" title="Scadenze suddivise mese per mese in un anno">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>Esporta calendario scadenze
    </button>`;
  ref.parentElement?.insertBefore(span, ref.nextSibling);
  span.querySelector('#btnExportAuditXlsx').addEventListener('click', exportAuditXlsx);
  span.querySelector('#btnExportMatriceXlsx').addEventListener('click', exportMatricePivotXlsx);
  span
    .querySelector('#btnExportScadenzeAnnoXlsx')
    .addEventListener('click', exportScadenzeAnnualiXlsx);
}

// I preset si agganciano accanto a btnExportXLSX (vista "clienti", lazy).
document.addEventListener('DOMContentLoaded', mountPresetButtons);
// @ts-ignore — bus globale (event-bus.js)
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') mountPresetButtons();
});

// @ts-ignore — global
Object.assign(globalThis, {
  exportAuditXlsx,
  exportMatricePivotXlsx,
  exportScadenzeAnnualiXlsx,
  mountXlsxPresets: mountPresetButtons
});
export {};
